import { render, staticRenderFns } from "./GatSelectItem.vue?vue&type=template&id=7c4da095&scoped=true"
import script from "./GatSelectItem.vue?vue&type=script&lang=js"
export * from "./GatSelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4da095",
  null
  
)

export default component.exports